import { Link } from "react-router-dom";
import { CONTACT, NAV_LINKS } from "@/data/services";

export default function Footer() {
  return (
    <footer className="bg-[#0D1F12] text-[#A3D9A5] pt-12 pb-28 md:pb-12 border-t border-[#1E5631]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8 text-xs sm:text-sm">
          <div className="space-y-3">
            <div className="text-white font-black text-lg tracking-wider font-display">ZWILLINGSWERK</div>
            <p className="text-[#84AF86] text-xs leading-relaxed">
              Garten- &amp; Hausmeisterservice aus Herten. Zwei Brüder, feste Preise, saubere Ergebnisse im gesamten Vest.
            </p>
          </div>
          <div className="space-y-2">
            <div className="text-white font-bold text-xs uppercase tracking-wider">Leistungen</div>
            <ul className="space-y-1.5 text-xs text-[#84AF86]">
              {NAV_LINKS.slice(1, 6).map((l) => (
                <li key={l.to}>
                  <Link to={l.to} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="hover:text-white transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="space-y-2">
            <div className="text-white font-bold text-xs uppercase tracking-wider">Service &amp; Infos</div>
            <ul className="space-y-1.5 text-xs text-[#84AF86]">
              <li>
                <Link to="/ueber-uns" data-testid="footer-link-ueber-uns" className="hover:text-white transition-colors">
                  Über uns
                </Link>
              </li>
              <li>
                <Link to="/kontakt" data-testid="footer-link-kontakt" className="hover:text-white transition-colors">
                  Kontakt &amp; Anfahrt
                </Link>
              </li>
              <li>
                <a href={CONTACT.phoneHref} data-testid="footer-phone-link" className="hover:text-white transition-colors">
                  {CONTACT.phoneDisplay}
                </a>
              </li>
              <li>
                <a href={CONTACT.emailHref} data-testid="footer-mail-link" className="hover:text-white transition-colors">
                  {CONTACT.email}
                </a>
              </li>
            </ul>
          </div>
          <div className="space-y-2">
            <div className="text-white font-bold text-xs uppercase tracking-wider">Rechtliches</div>
            <ul className="space-y-1.5 text-xs text-[#84AF86]">
              <li>
                <Link to="/impressum" data-testid="footer-link-impressum" className="hover:text-white transition-colors">
                  Impressum
                </Link>
              </li>
              <li>
                <Link to="/datenschutz" data-testid="footer-link-datenschutz" className="hover:text-white transition-colors">
                  Datenschutz
                </Link>
              </li>
            </ul>
            <div className="pt-2 text-[11px] text-[#5D7761]">
              {CONTACT.street}, {CONTACT.city}
            </div>
          </div>
        </div>
        <div className="border-t border-[#1E5631]/60 pt-6 flex flex-col sm:flex-row items-center justify-between text-xs text-[#6B856F] gap-2">
          <div>© {new Date().getFullYear()} ZWILLINGSWERK – Garten- &amp; Hausmeisterservice Herten</div>
          <div className="italic">{CONTACT.slogan}</div>
        </div>
      </div>
    </footer>
  );
}
